import { render, staticRenderFns } from "./ShopsTableMobile.vue?vue&type=template&id=4061b691&scoped=true"
import script from "./ShopsTableMobile.vue?vue&type=script&lang=js"
export * from "./ShopsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ShopsTableMobile.vue?vue&type=style&index=0&id=4061b691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061b691",
  null
  
)

export default component.exports